import React from 'react';
import './XiLogo.css';

/**
 * Xi product mark — the supplied triangular neon-sphere logo.
 *
 * This is the Xi brand identity. It is deliberately distinct from the
 * floating assistant avatar (monster asset) which is a separate product
 * element and must never be merged with this mark.
 *
 * @param {object} props
 * @param {'sm'|'md'|'lg'} [props.size='md']  Visual size step.
 * @param {boolean} [props.wordmark=true]     Show the "Xi" wordmark beside the mark.
 * @param {boolean} [props.tagline=false]     Show the small descriptor under the wordmark.
 * @param {string}  [props.className='']      Extra class names for layout contexts.
 * @param {string}  [props.label='Xi']        Accessible name; pass '' when decorative.
 */
export default function XiLogo({
  size = 'md',
  wordmark = true,
  tagline = false,
  className = '',
  label = 'Xi',
}) {
  const decorative = !label;
  return (
    <span
      className={`xi-logo xi-logo--${size} ${className}`.trim()}
      role={decorative ? 'presentation' : 'img'}
      aria-label={decorative ? undefined : label}
      aria-hidden={decorative ? 'true' : undefined}
    >
      <span className="xi-logo__mark" aria-hidden="true">
        <img
          className="xi-logo__mark-img"
          src="/assets/branding/xi-triad-logo.png"
          alt=""
          draggable={false}
        />
      </span>

      {wordmark && (
        <span className="xi-logo__text">
          <span className="xi-logo__word">Xi</span>
          {tagline && (
            <span className="xi-logo__tag">wellbeing intelligence</span>
          )}
        </span>
      )}
    </span>
  );
}
